import type { AddToCartResolvedScreen, ResolveAddToCartScreenInput } from "~/features/addToCart/flow/types";

export function resolveAddToCartScreen({ descriptorFacts }: ResolveAddToCartScreenInput): AddToCartResolvedScreen {
  if (descriptorFacts.isLoaded) {
    if (descriptorFacts.hasContractAvailable) {
      return "contractAvailable";
    }

    if (descriptorFacts.isKitWithSelectableParts) {
      return "kitSummary";
    }

    return "defaultForm";
  }

  if (descriptorFacts.isError) {
    return "errorLoading";
  }

  return "loading";
}
